import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";

const MenuPopupCaret = styled.div`
  border: solid transparent;
  border-bottom-color: rgba(0, 0, 0, 0.4);
  border-width: 7px;
  bottom: 100%;
  margin: 0 0 0 -8px;
  position: absolute;
  right: 18px;
  z-index: 10;

  &::after {
    box-shadow: 0px -1px 4px 0px rgba(0, 0, 0, 0.2);
    content: "";
    height: 1px;
    position: absolute;
    right: -7px;
    top: 3px;
    transform: rotate(45deg);
    width: 8px;
  }

  &::before {
    border: solid transparent;
    border-bottom-color: #fff;
    border-width: 8px;
    bottom: 100%;
    content: "";
    margin: 0 0 0 -8px;
    position: absolute;
    right: -8px;
    top: -8px;
    z-index: 11;
  }
`;

const MenuPopupContent = styled.div`
  background: #fff;
  border: 1px solid ${colors.rabbitGrey};
  box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
  display: ${props => (props.isActive ? "inline-block" : "none")};
  height: auto;
  position: relative;
  right: -15px;
  webkit-font-smoothing: antialiased;
  width: 100%;
`;

MenuPopupCaret.displayName = "MenuPopupCaret";
MenuPopupContent.displayName = "MenuPopupContent";

export { MenuPopupCaret, MenuPopupContent };
